const ChatTopicType = Object.freeze({
  TOP_LEVEL: 'TOP_LEVEL',
  FUND: 'FUND',
  FUND_FIELD: 'FUND_FIELD',
  FUND_LIST_ITEM: 'FUND_LIST_ITEM',
  DOCUMENT: 'DOCUMENT',
});

// Custom serialization rather than json to ensure the same topic always produces the same serialized string; json can have properties' order vary
const PROPERTY_ORDER = [
  'topicType',
  'topicId',
  'fieldName',
  'listItemId',
  'listItemType',
  'uiConfigSectionName',
];
const serializeTopic = (topic) => {
  const serialized = [];
  for (const property of PROPERTY_ORDER) {
    if (!topic[property]) {
      break;
    }
    serialized.push(topic[property]);
  }
  return serialized.join(':');
};

const deserializeTopic = (serialized) => {
  const [
    topicType,
    topicId,
    fieldName,
    listItemId,
    listItemType,
    uiConfigSectionName,
  ] = serialized.split(':');
  return {
    topicType,
    topicId,
    fieldName,
    listItemId,
    listItemType,
    uiConfigSectionName,
  };
};

export { ChatTopicType, serializeTopic, deserializeTopic };
